import { AmplitudeEvents, AmplitudeEventsCategories } from 'src/enums/amplitude.events';
import AnalyticsService from 'src/services/AnalyticsService';

export const createAcceptedTosEvent = () => {
    AnalyticsService.logEvent({
        name: AmplitudeEvents.TOS_READ_AND_ACCEPTED,
        payload: {
            type: 'event',
            environment: 'web',
            category: [AmplitudeEventsCategories.ANALYTICS],
        },
    });
};

export const createJournalEvent = () => {
    AnalyticsService.logEvent({
        name: AmplitudeEvents.JOURNAL_CREATED,
        payload: {
            type: 'event',
            environment: 'web',
            category: [AmplitudeEventsCategories.ANALYTICS],
        },
    });
};

export const acceptSessionEvent = () => {
    AnalyticsService.logEvent({
        name: AmplitudeEvents.SESSION_ACCEPTED,
        payload: {
            type: 'event',
            environment: 'web',
            category: [AmplitudeEventsCategories.ANALYTICS],
        },
    });
};
